/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { initFlowbite } from 'flowbite'

import { useDispatch, useSelector } from 'react-redux'

import { _object } from 'utils/interfaces'

import { brandsService } from 'services/brand.service'

import { Pagination } from 'components'
import AddNewBrandModal from 'components/modal/add-new-brand'
import EditBrandModal from 'components/modal/edit-brand-modal'

import { DeleteIcon, EditIcon, ViewIcon } from 'assets/svg'
import { Placeholder } from 'assets/images'
import { setBrandFilterData } from '../redux/slices/filter.slice'

const Brands = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [results, setResults] = useState<_object>({})
  // const [selectedBrandId, setSelectedBrandId] = useState<string | null>(null)
  const savedFilters = useSelector((state: _object) => state.filter.brandFilter)

  const [filters, setFilters] = useState(
    Object.keys(savedFilters || {}).length ? savedFilters : {
      q: '',
      page: 1,
      per_page: 25,
      sort: 'created_at'
    }
  )

  const getAllBrand = () => {
    brandsService.getBrands(filters).then((results) => {
      setResults(results)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    getAllBrand()
  }, [filters])

  useEffect(() => {
    dispatch(setBrandFilterData(filters))
  }, [filters])

  const deleteBrand = (id: string) => {
    if (window.confirm('Are you sure you want to delete?')) {
      brandsService.deleteBrand(id).then(() => {
        getAllBrand()
      })
    }
  }
  useEffect(() => {
    initFlowbite()
  })



  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">
          Brands <small>Total records: {results?.pagination?.total_items}</small>
        </h1>
        <button
          className="rounded-md border border-purple-900 bg-purple-900 hover:bg-purple-950 font-medium px-4 py-2 text-sm text-white"
          data-modal-target="add-new-brand"
          data-modal-toggle="add-new-brand"
          type="button"
        >
          Add New Brand
        </button>
      </div>

      <div className="mb-4">
        <form>
          <div className="">
            <div className="flex items-center gap-2">
              <input
                type="search"
                placeholder="Search keyword"
                className="w-60 rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
                value={filters.q || ''}
                onChange={(e) => {
                  setFilters({ ...filters, q: e.target.value })
                }}
              />
            </div>
          </div>
        </form>
      </div>

      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold">#</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Description</th>
              <th className="px-4 py-3 font-semibold">Featured</th>
              <th className="text-semibold px-4 py-3 text-start">
                <p className="ms-4 text-sm font-semibold text-gray-900">Image</p>
                <span className="whitespace-nowrap mb-2 text-[10px] text-[#969494] font-medium">275W × 183H | 3:2</span>
              </th>

              <th className="px-4 py-3 text-end font-semibold">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {loading === false ? (
              results?.items?.map((item: _object, i: number) => {
                return (
                  <>
                    <tr className="hover:bg-gray-50" key={i}>
                      <td className="px-4 py-3">{i + 1}</td>
                      <td className="px-4 py-3">{item?.title}</td>
                      <td className="px-4 py-3">{item?.description}</td>
                      <td className="px-4 py-3">{item?.featured ? '★' : '☆'}</td>
                      <td className="px-4 py-3">
                        <div className="h-[50px] w-[50px]">
                          <img
                            src={item?.image || Placeholder}
                            alt={item.title}
                            className="rounded-md h-full w-full object-cover"
                          />
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex h-full items-center justify-end gap-2">
                          <Link
                            title="View details"
                            target="blank"
                            to={`https://treasuresunlimited.vercel.app/products?brand=${item?.slug}`}
                          >
                            <ViewIcon />
                          </Link>

                          <button
                            type="button"
                            onClick={() => deleteBrand(item.id)}
                            title="Delete Brand"
                          >
                            <DeleteIcon className="h-[20px] w-[20px]" />
                          </button>

                          <button
                            data-modal-target={`band-modal${item?.id}`}
                            data-modal-toggle={`band-modal${item?.id}`}
                            type="button"
                            title="Edit Brand"
                          // onClick={() => {
                          //   setSelectedBrandId(item.id)
                          // }}
                          >
                            <EditIcon className="h-[20px] w-[20px]" />
                          </button>
                        </div>
                      </td>
                    </tr>
                    <EditBrandModal id={item.id} />
                  </>
                )
              })
            ) : (
              <Skeleton />
            )}
            {results?.items?.length <= 0 &&
              <td colSpan={12} className="text-center py-6 text-gray-500">
                <p>No record found</p>
              </td>
            }
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {results?.pagination?.total_pages > 1 && (
        <Pagination
          pageCount={results?.pagination?.total_pages}
          current_page={results?.pagination?.current_page}
          onPageChange={(e: _object) => {
            setFilters({ ...filters, page: e.selected + 1 })
          }}
        />
      )}

      <AddNewBrandModal />
    </>
  )
}

export default Brands

const Skeleton = () => {
  return (
    <tr className="animate-pulse">
      <td className="px-4 py-3">
        <div className="h-4 w-6 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-32 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-12 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-12 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-12 rounded bg-gray-300"></div>
      </td>

      <td className="flex justify-end gap-2 px-4 py-3">
        <div className="h-5 w-5 rounded-full bg-gray-300"></div>
        <div className="h-5 w-5 rounded-full bg-gray-300"></div>
        <div className="h-5 w-5 rounded-full bg-gray-300"></div>
      </td>
    </tr>
  )
}
